import { IViewFn, IViewConstructor } from "@dhx/ts-layout";
import { IView } from "@dhx/ts-common/view";

export interface IWindowConfig {
	css?: string;

	title?: string;
	html?: string;

	minWidth?: number;
	minHeight?: number;

	left?: number;
	top?: number;
	width?: number;
	height?: number;

	footer?: boolean;
	header?: boolean;
	viewportOverflow?: boolean;
	resizable?: boolean;
	movable?: boolean;
	modal?: boolean;
	closable?: boolean;
}
export interface IPosition {
	left: number;
	top: number;
}
export interface ISize {
	width: number;
	height: number;
}
export interface IWindow {
	setSize(width: number, height: number): void;
	getSize(): ISize;
	setPosition(left: number, top: number): void;
	getPosition(): IPosition;
	getWidget(): any;
	getContainer(): HTMLElement;

	show(left: number, top: number): void;
	hide(): void;
	isVisible(): boolean;
	attach(name: string | IViewFn | IView | IViewConstructor, config?: any): void;
	attachHTML(html: string): void;
	destructor(): void;
	paint(): void;
	setFullScreen(): void;
	// TODO: remove sute_7.0
	fullScreen(): void;
}
export interface IResizeConfig {
	left?: boolean;
	right?: boolean;
	top?: boolean;
	bottom?: boolean;
}

export enum WindowEvents {
	resize = "resize", // [size, oldsize, editettypes]
	headerDoubleClick = "headerdoubleclick", // []
	move = "move", // [left, top]
	afterShow = "aftershow",
	afterHide = "afterhide",
	beforeShow = "beforeshow",
	beforeHide = "beforehide"
}